module.exports = __webpack_public_path__ + "static/media/video.8a80a1e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyTurfClub/video.jpg
// module id = 207
// module chunks = 0